import { Billet } from '../interfaces/billets';

export const getBilletNumber = (billet: Billet): string => {
  return (
    billet.digitable_or_bar_code || billet.digitable || billet.bar_code || ''
  );
};
